export const SoundtrackMapping = {
    embedUrl: 'specific.sound.embedUrl'
};
